import React, {Component} from 'react'
import {Provider} from 'react-redux'
import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/database'
import 'firebase/messaging'
import 'firebase/storage'
import 'firebase/firestore' // make sure you add this for firestore
import {connect} from "react-redux";

import {ReactReduxFirebaseProvider, useFirestore} from 'react-redux-firebase'
import {createFirestoreInstance} from 'redux-firestore'
import configureStore from './store'
import {firebase as fbConfig, rrfConfig} from './config'
import './App.css'
import 'antd/dist/antd.css';
import styled from 'styled-components'
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Link,
    Redirect
} from "react-router-dom";
import {useSelector} from 'react-redux'
import {isLoaded, isEmpty} from 'react-redux-firebase'
import Login from "./pages/auth/Login";
import Profile from "./pages/auth/Profile";
import LoginPage from "./LoginPage";
import ActiveCalls from "./pages/calls/ActiveCalls";
import Home from "./pages/Home";
import MyCalls from "./pages/calls/MyCalls";
import Register from "./pages/auth/Register";
import EmployeeRequest from "./pages/auth/EmployeeRequest";
import CompanySettings from "./pages/auth/CompanySettings";
import ExclusiveCalls from "./pages/calls/ExclusiveCalls";
import {
    COMPANY_CALLS_URL, COMPANY_SERVICE_PRICES_URL,
    COMPANY_SETTINGS_URL,
    DETAILED_CALL_URL, EMPLOYEE_SETTINGS_URL,
    EXCLUSIVE_CALL_URL, LOGIN_URL,
    MY_CALLS_URL, PROFILE_SETTINGS_URL,
    PROFILE_URL,
    REGISTER_URL
} from "./constants/URLS";
import DetailedCall from "./pages/calls/DetailedCall";
import CompanyCalls from "./pages/calls/CompanyCalls";
import withMyCoordsHOC from "./components/MyCoordsHOC";
import TestList from "./pages/TestList";
import EmployeeSettings from "./pages/auth/EmployeeSettings";
import ProfileSettings from "./pages/auth/ProfileSettings";
import CompanyServicePrices from "./components/CompanyServicePrices";
import Navbar from "./components/Navbar";
import AuthLoadingWrapper from "./components/auth/AuthLoadingWrapper";
import {NavbarComponent} from "./components/Navbar/NavbarComponent";

const initialState = window && window.__INITIAL_STATE__ // set initial state here
const store = configureStore(initialState)

firebase.initializeApp(fbConfig)
firebase.firestore()


const messaging = firebase.messaging()
messaging.requestPermission().then(() => {
    return messaging.getToken()
}).then(token => {
    console.log(token)
    localStorage.setItem('fcmToken', token)
    localStorage.setItem('sendToServer', false)

}).catch(err => {
    console.log('err token')
})

messaging.onMessage((payload) => {
    console.log('Message received. ', payload);
});

function FCMcheck() {
    const profile = useSelector(state => state.firebase.profile)
    if (isLoaded(profile) && !isEmpty(profile) && !!localStorage.getItem('sendToServer')) {
        if (!profile.fcmToken || profile.fcmToken !== localStorage.getItem('fcmToken')) {
            console.log('set fcm token')
            firebase.updateProfile({
                fcmToken: localStorage.getItem('fcmToken')
            })
            localStorage.setItem('sendToServer', true)
        }
    }
    return null
}

class App extends Component {
    render() {
        return (
            <Provider store={store}>
                <ReactReduxFirebaseProvider
                    firebase={firebase}
                    config={rrfConfig}
                    dispatch={store.dispatch}
                    createFirestoreInstance={createFirestoreInstance}>
                    <AuthLoadingWrapper>
                        <Router>

                            <NavbarComponent/>

                            <PageContainer>
                                <Switch>

                                    <Route path={'/calls/actives'}><ActiveCalls/></Route>
                                    <Route path={EXCLUSIVE_CALL_URL}><ExclusiveCalls/></Route>
                                    <Route path={MY_CALLS_URL}><MyCalls/></Route>
                                    <Route path={COMPANY_CALLS_URL}><CompanyCalls/></Route>
                                    <Route path={'/calls/subscribe'}>
                                        <div>
                                            <h1>subscribe</h1>
                                        </div>
                                    </Route>


                                    {/*User profile, settings etc...*/}
                                    <Route path={PROFILE_URL}><Profile/></Route>
                                    <Route path={LOGIN_URL}><Login/></Route>
                                    <Route path={REGISTER_URL}><Register/></Route>
                                    <Route path={'/employee-requests'}><EmployeeRequest/></Route>
                                    <Route path={COMPANY_SETTINGS_URL}><CompanySettings/></Route>
                                    <Route path={COMPANY_SERVICE_PRICES_URL}><CompanyServicePrices/></Route>
                                    <Route path={EMPLOYEE_SETTINGS_URL}><EmployeeSettings/></Route>
                                    <Route path={PROFILE_SETTINGS_URL}><ProfileSettings/></Route>
                                    <Route path={DETAILED_CALL_URL + ':id'}><DetailedCall/></Route>


                                    <Route path={'/'}><Home/></Route>
                                </Switch>
                            </PageContainer>
                            {/*
                        <FCMcheck/>
*/}

                        </Router>
                    </AuthLoadingWrapper>
                </ReactReduxFirebaseProvider>
            </Provider>
        );
    }
}


export default App

const PageContainer = styled.div`
margin-left: 400px;
width: auto;
height: 100%;
min-height: 100vh;
position: relative;
overflow: auto;
@media only screen and (max-width: 1250px){
  margin-left: 0;
}
`



